export const isProductDiscontinued = (product) => product.isDiscontinued;

export const isProductUnavailableForUS = () => false;

export const isProductUnavailable = (product) => {
  return isProductDiscontinued(product);
};
